import omit from 'lodash/omit';

const isActive = (state, space, key) => {
  const subState = state[space];
  return Boolean(subState[key]);
};

const subToggle = (subState, key, value) =>
  subState[key] ? omit(subState, key) : {...subState, [key]: (value || 1)};

export default (state, space, key, value) => {
  const subState = state[space];
  return {[space]: subToggle(subState, key, value)};
};

export {isActive, subToggle};



// WEBPACK FOOTER //
// ./src/reducers/toggle.js